import { useContext, useEffect, useState }  from 'react';
import { BannerContext } from '../../contexts/BannerDimensionsContext';
import './index.css'
import { MasterToReplicate } from '../../helpers/masterToReplicate.js';
import { Divider, formatMs } from '@material-ui/core';
import { resizedataURL } from '../../helpers/printElement';
import { AuthValidatorContext } from '../../contexts/auth';
import FormatosReanimate from '../../res/formatosReanimate.js'

export default function ModalFormatos(props) {
  const { setReplicate, replicate, master, setReplicaActive, openFormatsVideo, setOpenFormatsVideo, openFormatsHTML, setOpenFormatsHTML, openFormatsRetail,
    openFormatsHorizontal, setOpenFormatsHorizontal, openFormatsVertical, setOpenFormatsVertical, setOpenFormatsRetail, openFormatsMobile, setOpenFormatsMobile,
    openFormatsQuadrado, setOpenFormatsQuadrado, setListaReplicas, listaReplicas, openCategoryCustom, setOpenCategoryCustom
  } = useContext(BannerContext);
  const [ typesFormats, setTypesFormats ] = useState([]);
  const [inputCustomWidth, setInputCustomWidth] = useState();
  const [inputCustomHeight, setInputCustomHeight] = useState();
  const { client } = useContext(AuthValidatorContext);

  useEffect(() => {
    setReplicate(FormatosReanimate(client));
  }, [client]);

  async function controlReplicate(item, custom = false) {
    const copyFormats = JSON.parse(JSON.stringify(replicate));
    let copyListaReplicas = JSON.parse(JSON.stringify(listaReplicas));
    let check = !item.ativo;
    let isIncluded = false;
    listaReplicas.forEach(replica => {
      if (Number(replica.width) === Number(item.width) && Number(replica.height) === Number(item.height) && check) {
        isIncluded = true;
      }
    });

    if (isIncluded) return;
    if (listaReplicas.length) {
      let formatAlreadyIncluded = false;
      listaReplicas.forEach(replic => {
        if (replic.width === Number(item.width) && replic.height === Number(item.height)) 
            formatAlreadyIncluded = true;
      });
    }

    if (check || custom) {
      const newRes = await MasterToReplicate(JSON.parse(JSON.stringify(master)), item);
      newRes.pack = true;
      newRes.type = item.type;
      newRes.elements.forEach(async (element, i) => {
        if (element.reduce) {
          const bg = element.properties.originalBackground.replaceAll("'", "");
          const scale = element.properties.scale;
          element.properties.background = resizedataURL(bg, element.properties.width * scale / 100, element.properties.height * scale / 100);
        }
      });
      copyListaReplicas.push(newRes);
      if (copyListaReplicas.length === 1) setReplicaActive(`${item.width}x${item.height}`)
    } else {
      copyListaReplicas = copyListaReplicas.filter((value) => 
        Number(value.width) !== Number(item.width) || Number(value.height) !== Number(item.height)
      );
    }
    setListaReplicas(copyListaReplicas);
          console.log('05')
    setReplicate(copyFormats);
  }

  function addCustom() {
    if (!inputCustomWidth || !inputCustomHeight) return;

    var width = inputCustomWidth;
    var height = inputCustomHeight;
    var custom = {};
    custom.width = Number(width);
    custom.height = Number(height);
    custom.type = "Custom";
    custom.ativo = true;
    controlReplicate(custom, true);
  }

  function handleClickCategory(item) {
    let copyFormats = JSON.parse(JSON.stringify(replicate));
    let index = copyFormats.folders.findIndex(x => x.name === item.name);
    copyFormats.folders[index].openned = !copyFormats.folders[index].openned;
    copyFormats.folders.forEach(element => {
      if (element.parent === item.name) {
        element.show = !element.show;
      }
    });
    copyFormats.formats.forEach(element => {
      if (element.parent === item.name) {
        element.show = !element.show;
      }
    });
          console.log('06')
    setReplicate(copyFormats);
  } 

  function handleClickFormat(format) {
    let copyFormats = JSON.parse(JSON.stringify(replicate));
    copyFormats.formats.forEach(element => {
      if (element.parent === format.parent && element.id === format.id) {
        element.ativo = !element.ativo;
        let item = document.getElementById(`checkbox${element.width}X${element.height}`);
        item.checked = element.ativo;
      }
    });
          console.log('07')
    setReplicate(copyFormats);
    controlReplicate(format);
  }

  console.log('replicate')
  console.log(replicate)

  return (
    <div className="modal-formatos-root">
      {
        replicate && replicate.folders && replicate.folders.filter(x => x.show).map((item, index) => (
          <div key={index} className="format-item">
            <div className="formatNameAndArrow" style={{marginLeft: item.parent ? '24px' : '13px'}} onClick={() => handleClickCategory(item)}>
              <span
                className="f-estilos title"
                style={{
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  fontSize: item.parent ? '14px' : '16px',
                  color: '#222222',
                  userSelect: 'none',
                }}
              >
                {item.name}
              </span>
              { item.openned ?
                <img alt='img' src="assets/arrownew.png" className="stepNumberArrowUp" style={{padding: '5px', cursor: 'pointer', width: '11px', height: '7px', margin: '12px 0 0 0'}}/> :
                <img alt='img' src="assets/arrownew.png" className="stepNumberArrowUp" style={{transform: "rotate(180deg)", padding: '5px', cursor: 'pointer', width: '11px', height: '7px', margin: '12px 0 0 0', userSelect: 'none'}}/>
              }
            </div>
            {
              replicate && replicate.formats && replicate.formats.filter(x => x.parent === item.name).map((format) => (
                <div style={{display: format.show ? 'flex' : 'none', alignItems: 'center', marginLeft: '40px'}} key={format.id}>
                  <input
                    onChange={() => handleClickFormat(format)}
                    name={format.width + "x" + format.height}
                    id={`checkbox${format.width}X${format.height}`}
                    type="checkbox"
                    defaultChecked={format.ativo}
                    style={{margin: '-2px 0 0 0', accentColor: '#68498C'}}
                  />
                  <span 
                    style={{margin: '0 0 0 8px', fontSize: '15px', cursor: 'pointer', fontWeight: 'normal', color: '#000000'}}
                    onClick={() => document.getElementById(`checkbox${format.width}X${format.height}`).click()}>
                    {`${format.width}x${format.height}`}
                  </span>
                </div>
              ))
            }
          <Divider className='leftMenuDivider'/>
          </div>
      ))
    }
      <div className="f-estilos-Custom">
        <div className='formatNameAndArrow' onClick={() => setOpenCategoryCustom(!openCategoryCustom)}>
          <span className="f-estilos title" style={{fontWeight: 'bold', cursor: 'pointer', fontSize: '16px', color: '#222222', userSelect: 'none'}} onClick={() => setOpenCategoryCustom(!openCategoryCustom)}>CUSTOM</span>
          {openCategoryCustom ?
            <img alt='img' src="assets/arrownew.png" className="stepNumberArrowUp" onClick={() => setOpenCategoryCustom(!openCategoryCustom)} style={{padding: '5px', cursor: 'pointer', width: '11px', height: '7px', margin: '12px 0 0 0'}}/> :
            <img alt='img' src="assets/arrownew.png" className="stepNumberArrowUp" onClick={() => setOpenCategoryCustom(!openCategoryCustom)} style={{transform: "rotate(180deg)", padding: '5px', cursor: 'pointer', width: '11px', height: '7px', margin: '12px 0 0 0', userSelect: 'none'}}/>
          }
        </div>
        <Divider className='leftMenuDivider'/>
        {openCategoryCustom ?
          <div className="formats-container-custom">
            <input value={inputCustomWidth} onChange={event => setInputCustomWidth(event.target.value.replace(/\D/g, ''))} placeholder='Largura' type='text' inputmode="numeric" pattern="\d+" />
            <span className='xSpan'>X</span>
            <input value={inputCustomHeight} onChange={event => setInputCustomHeight(event.target.value.replace(/\D/g, ''))} placeholder='Altura' type='text' inputmode="numeric" pattern="\d+" />
            <svg onClick={() => addCustom()} className='addButton' xmlns="http://www.w3.org/2000/svg" width="32" height="36.316" viewBox="0 0 32 36.316">
              <g id="Group_479" data-name="Group 479" transform="translate(0 2)">
                <rect id="Rectangle_246" data-name="Rectangle 246" width="32" height="32" rx="4" transform="translate(0 2.316)" fill="#68498c"/>
                <text id="Africa" transform="translate(7 26)" fill="#fff" font-size="26" font-family="SegoeUI-Bold, Segoe UI" font-weight="700"><tspan x="0" y="0">+</tspan></text>
              </g>
            </svg>
        </div>: <></>}
    </div>
  </div>
)}
